// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/modal.scss
// module id = 336
// module chunks = 2